// ====================
//  375px以下でviewportを固定にする
// ====================

function viewport() {
  const metaViewport = document.querySelector('meta[name="viewport"]');
  if (!metaViewport) return;

  let resizeFrame = 0;

  const updateViewport = () => {
    const value = window.outerWidth > 375 ? 'width=device-width,initial-scale=1' : 'width=375';
    if (metaViewport.getAttribute('content') !== value) {
      metaViewport.setAttribute('content', value);
    }
  };

  const onResize = () => {
    if (resizeFrame) return;
    resizeFrame = requestAnimationFrame(() => {
      resizeFrame = 0;
      updateViewport();
    });
  };

  updateViewport();
  window.addEventListener('resize', onResize);
}

export { viewport };
